import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { track } from "../features/analytics/tracker";
import { leadImageFor } from "../assets/utils/productImages";
import { getStartingPrice } from "../assets/utils/productUtils";

// "This week's harvest" - driven by the harvestHighlight flag set from the
// farm-dashboard catalogue page. Renders nothing if no products are featured
// (or the fetch fails), so it can never break the homepage.

const fadeUp = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.35 },
};

export default function HarvestStrip() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch("https://teardrophydro.co.uk/garageFarm/products");
        const data = await res.json();
        if (!alive || !Array.isArray(data)) return;
        const picks = data.filter((p) => p?.enabled !== false && p?.harvestHighlight);
        setFeatured(picks);
        if (picks.length) track("harvest_strip_view", { count: picks.length });
      } catch {
        /* strip simply doesn't render */
      }
    })();
    return () => { alive = false; };
  }, []);

  if (!featured.length) return null;

  return (
    <section className="section" style={{ paddingBottom: 0 }}>
      <div className="container">
        <motion.div {...fadeUp}>
          <div className="harvest-strip__head">
            <div>
              <p className="eyebrow" style={{ marginBottom: 4 }}>Fresh off the benches</p>
              <h2 className="h2" style={{ margin: 0 }}>This week's highlights</h2>
            </div>
            <Link to="/browse-products" className="harvest-strip__all">
              See everything →
            </Link>
          </div>

          <div className="harvest-strip">
            {featured.map((p) => {
              const img = leadImageFor(p);
              return (
                <Link
                  key={p.id}
                  to={`/product/${p.id}`}
                  className="harvest-card"
                  onClick={() => track("harvest_strip_click", { productId: p.id, name: p.name })}
                >
                  <div className="harvest-card__imgwrap">
                    {img ? (
                      <img src={img} alt={p.name} loading="lazy" />
                    ) : (
                      <div className="harvest-card__placeholder" aria-hidden="true">🌿</div>
                    )}
                  </div>
                  <div className="harvest-card__body">
                    <strong>{p.name}</strong>
                    {typeof p.price === "number" && (
                      <span className="muted">From £{getStartingPrice(p).price}</span>
                    )}
                  </div>
                </Link>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
